module.exports = __webpack_public_path__ + "img/BT_close.633853ff.svg";